import { SearchScreen } from "@/app/modules/Search/SearchScreen.tsx";

export const Search = () => {
  return <SearchScreen />;
};
